import React from 'react';
import { Indicators } from './AppComponents';

const ContainerCoverVideo = props => {
    return (
        <div className="dr-container-video-cover">
            <div dangerouslySetInnerHTML={{
                __html: `<video playsInline preload="auto" id='sdg${props.id}-video' className="video-js report-video" poster=${props.poster} autoPlay=${true} muted="muted">
                <source src=${props.video} type="video/mp4" />
                <p className="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that <a href="http://videojs.com/html5-video-support/" target="_blank" rel="noreferrer">supports HTML5 video</a></p>
            </video>`,
            }}
            />
            <div className="sdg-video-cover-title">
                <img src={props.sdgImage} alt="SDG 2 Target" />
                <div className="sdg-video-cover-title-text">
                    <h2>{props.sdg}</h2>
                    <h1>{props.title}</h1>
                    <p>{props.subtitle}</p>
                    { props.summaryTable ? renderSummaryTable(props.summaryTable, props.summaryTableTitle) : '' }
                   { props.summaryTableSecond ? renderSummaryTable(props.summaryTableLinkSecond, props.summaryTableSecond, true) : ''  }
                    { props.indicators ? <Indicators indicators={props.indicators} indicatorsTitle={props.indicatorsTitle} indicatorExtra={props.indicatorExtra}/> : ''}
                </div>
            </div>
        </div>
    ) 
}

const renderSummaryTable = (link, title, second) => {
    return(
        <React.Fragment>
            { second ? '' : <hr className="summary-table-hr summarytable-hr" /> }
            <a href={link} download className="summary-table-btn" target="_blank" rel="noreferrer">
                <span className="material-icons">table_view</span>
                <span className="summary-table-text">{title}</span>
            </a>
        </React.Fragment>   
    );
}

export default ContainerCoverVideo;
